import gql from 'graphql-tag';

export default gql`
  mutation cancelSubmission($submissionId: UUID!) {
    cancelSubmission(submissionId: $submissionId) {
      id
    }
  }
`;
